module.exports = __webpack_public_path__ + "img/07-attendance.a5bdf21a.png";